import { FRLoginFailure, FRStep, TextOutputCallback } from '@forgerock/javascript-sdk';
import { RealFailureDetail } from 'Services';

const isTimeoutError = (error: FRLoginFailure) =>
  error?.getCode() === 401 && (error?.getDetail() as RealFailureDetail)?.errorCode === '110';

const isOtpRetryLimitError = (error: FRLoginFailure, stage: Stage) =>
  error?.getCode() === 401 && error?.getMessage() === 'OTPRetryLimitExceededError' && stage === 'OTP Page';

const hasCallbackError = (step: FRStep | undefined): boolean =>
  !!step?.callbacks.find((callback) => callback instanceof TextOutputCallback && callback.getOutputValue('messageType') === '2');

const displayErrorPage = (withCallbackError: boolean, stage: Stage) =>
  withCallbackError && !['Retry or resend OTP', 'Connexion Page'].includes(stage);

export { isTimeoutError, isOtpRetryLimitError, hasCallbackError, displayErrorPage };
